/**
 * childTable 子表方法
 * @type {{}}
 */
const FormChildTable = {
	/**
	 * 过滤子表数据
	 * @param table 子表ref
	 * @param newData 需要过滤的数据
	 * @param checkStr 校验字段 ,分隔字符串或数组
	 * @returns {[]}
	 */
	insertRow(table, newData, checkStr) {
		let checkKey = [];
		if (typeof checkStr == 'string') {
			checkKey = checkStr ? checkStr.split(',') : [];
		} else if (Array.isArray(checkStr)) {
			checkKey = checkStr;
		}
		let oldData = table.getTableData().fullData;
		let insertArr = [];
		for (let i = 0; i < newData.length; i++) {
			let has = false;
			for (let j = 0; j < oldData.length; j++) {
				let num = 0;
				for (let k = 0; k < checkKey.length; k++) {
					if (oldData[j][checkKey[k]] === newData[i][checkKey[k]]) {
						num++;
					}
				}
				if (num === checkKey.length) {
					has = true;
					break;
				}
			}
			if (!has) {
				insertArr.push(newData[i]);
			}
		}
		return insertArr;
	}
}

export {
	FormChildTable
}